// The editors keep one copy of the data per side: "berangkat" and "kembali".
// createSideUpdater returns updateSide(type, update): it runs `update` on the current value of the side named by
// `type` ("berangkat" -> berangkat, anything else -> kembali) and stores what `update` returns.
// `update` gets the latest value of the side (also when an earlier update is still waiting for its response).
export const createSideUpdater =
  ({ setBerangkat, setKembali }) =>
  (type, update) => {
    if (type === "berangkat") {
      setBerangkat((current) => update(current));
    } else {
      setKembali((current) => update(current));
    }
  };
